export const API_STUDENTS_BASE_URL =
  process.env.REACT_APP_API_STUDENTS || "http://localhost:1338";
